export default __webpack_public_path__ + "static/media/secure.adbc3251.svg";